/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ConciergeDataset
 */
export interface ConciergeDataset {
  /**
   *
   * @type {number}
   * @memberof ConciergeDataset
   */
  readonly id: number;
  /**
   *
   * @type {boolean}
   * @memberof ConciergeDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {string}
   * @memberof ConciergeDataset
   */
  rawData: string;
}

/**
 * Check if a given object implements the ConciergeDataset interface.
 */
export function instanceOfConciergeDataset(value: object): value is ConciergeDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('rawData' in value) || value['rawData'] === undefined) return false;
  return true;
}

export function ConciergeDatasetFromJSON(json: any): ConciergeDataset {
  return ConciergeDatasetFromJSONTyped(json, false);
}

export function ConciergeDatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConciergeDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    hasPredictions: json['has_predictions'],
    rawData: json['raw_data'],
  };
}

export function ConciergeDatasetToJSON(value?: Omit<ConciergeDataset, 'id' | 'hasPredictions'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    raw_data: value['rawData'],
  };
}
